<ng-content></ng-content>
<app-spinner *ngIf="loadingAreaIndicatorActive"></app-spinner>
